<template>
  <div id="pdf-templates-table">
    <div class="header-line">
      <button class="btn btn-primary create-button" @click="createNewTemplate">
        {{ $t("pdf_templates_table.new") }}
      </button>
    </div>
    <div class="table-wrapper">
      <div class="rTable">
        <div class="rTableRow problem-header">
          <div
            class="rTableHead"
            v-for="(header, i) in headers"
            :key="i"
            :style="{ width: header.width + '%' }"
          >
            {{ header.text }}
          </div>
        </div>
        <div class="rTableRow" v-for="(template, i) in templates" :key="i">
          <div class="rTableCell">{{ template.name }}</div>
          <div class="rTableCell">
            <v-icon
              small
              class="mr-2"
              v-tooltip="$t('pdf_templates_table.edit')"
              @click="editItem(template)"
              >edit</v-icon
            >
            <v-icon
              small
              class="mr-2"
              v-tooltip="$t('pdf_templates_table.copy')"
              @click="copyItem(template)"
              >content_copy</v-icon
            >
            <v-icon
              small
              v-tooltip="$t('pdf_templates_table.delete')"
              @click="deleteItem(template)"
              >delete</v-icon
            >
          </div>
        </div>
      </div>
    </div>
    <PdfTemplateDialog ref="pdfTemplateDialog" @updated="initialize" />
  </div>
</template>

<script>
import PdfTemplateDialog from "@/components/admin/PdfTemplateDialog.vue";
export default {
  name: "pdf-templates-table",
  components: {
    PdfTemplateDialog,
  },
  props: {
    templates: {
      required: true,
      type: Array,
    },
  },
  data() {
    return {
      headers: [
        {
          text: this.$t("pdf_templates_table.name"),
          width: 70,
        },
        {
          text: this.$t("pdf_templates_table.actions"),
          width: 30,
        },
      ],
    };
  },
  methods: {
    initialize() {
      this.$emit("updated");
    },
    createNewTemplate() {
      if (this.$refs.pdfTemplateDialog) {
        this.$refs.pdfTemplateDialog.openCreate();
      }
    },
    editItem(template) {
      if (this.$refs.pdfTemplateDialog) {
        this.$refs.pdfTemplateDialog.openEdit(template);
      }
    },
    copyItem(template) {
      if (this.$refs.pdfTemplateDialog) {
        this.$refs.pdfTemplateDialog.openCreate(template);
      }
    },
    async deleteItem(template) {
      const confirmation = confirm("Ar tikrai norite ištrinti šį šabloną?");
      if (!confirmation) return;
      await template.delete();
      this.$emit("updated");
    },
  },
};
</script>

<style scoped>
.create-button {
  position: relative;
  margin-right: 20px;
  float: right;
}
</style>